const ScaleNavigation = {
  order: Infinity,
  run($$) {
    $$.$.on("seats:rendered", () => {
      const container = $("<div class=\"tc-section--scale-navigation\" />")
        .css({
          position: "absolute",
          top: 20,
          right: 0,
          width: $$.SEAT_WIDTH - 2,
          height: ($$.SEAT_HEIGHT * 2) + 4,
          backgroundColor: "rgba(238,238,238,0.7)",
          border: "1px solid rgba(238,238,238,0.9)",
          borderRadius: "4px 0 0 4px",
        });

      $("<button type=\"button\" class=\"tc-section--scale-navigation-zoom-in\" />")
        .css({
          width: $$.SEAT_WIDTH,
          height: $$.SEAT_HEIGHT,
        })
        .click(() => $$.scale($$.maxScale))
        .appendTo(container);

      $("<button type=\"button\" class=\"tc-section--scale-navigation-zoom-out\" />")
        .css({
          width: $$.SEAT_WIDTH,
          height: $$.SEAT_HEIGHT,
        })
        .click(() => $$.scale(1))
        .appendTo(container);

      container.appendTo($(".arena-workspace"));
    });
  },

};

window.SectionScaleNavigation = ScaleNavigation;

export default ScaleNavigation;
